import {
  ADD_QUERY,
  REMOVE_QUERY,
} from '../../actions/generic/types';

const initialState = {
  queries: []
};

const queries = (state = initialState, action) => {
  switch (action.type) {
    case ADD_QUERY:
      let newState = {
        ...state,
        //In our new copy of queries we filter out existing queries for the target panel and then add the new one, thus effectively replacing the existing query
        queries: [...state.queries.filter(x => (x.screenId != action.payload.screenId || x.targetPanelNr != action.payload.targetPanelNr)), action.payload]
      };
      // console.log('Queries in state:');
      // console.log(newState);
      return newState;
    case REMOVE_QUERY:
      //Todo: Do we even need an action like this? Leaving this only as a placeholder for now...
      return state;
      // return {
      //   ...state,
      //   queries: [...state.queries].filter(a => a.id !== action.id)
      // };
    default:
      return state;
  }
};

//export const getVisibleQuery = (state) => (state.queries && state.queries.length > 0) ? state.queries[0] : null;

export default queries;